/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} How_Page_Rail_GrowInputs */

const en_how_page_rail_grow = /** @type {(inputs: How_Page_Rail_GrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grow`)
};

const pl_how_page_rail_grow = /** @type {(inputs: How_Page_Rail_GrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rośnij`)
};

/**
* | output |
* | --- |
* | "Grow" |
*
* @param {How_Page_Rail_GrowInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const how_page_rail_grow = /** @type {((inputs?: How_Page_Rail_GrowInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<How_Page_Rail_GrowInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_how_page_rail_grow(inputs)
	return en_how_page_rail_grow(inputs)
});